/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MedalRegular from './medal-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MedalRegular {...validProps} />;
}
SvgComponent.iconName = 'medalRegular';

export const MedalRegularIcon = svgIconWrapper(SvgComponent);
